import api from '../../api/api'

// initial state
const state = {
	all: [],
  status: {
    getOpeningHours: null
  }
}

// getters
const getters = {}

// actions
const actions = {
  getOpeningHours ({ commit, state }, params) {
    commit('setStatus', { getOpeningHours: api.status.PENDING })
    return api.getOpeningHours(params).then((response) => {
      commit('setOpeningHours', response.data)
      commit('setStatus', { getOpeningHours: api.status.SUCCESS })
    }).catch((error) => {
      commit('setStatus', { getOpeningHours: api.status.FAILURE })
    })
  }
}

// mutations
const mutations = {
  setOpeningHours (state, openingHours) {
    state.all = openingHours;
  },
  setStatus (state, status) {
    Object.assign(state.status, status)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
